module.exports={render:function (){var _vm=this;
  return _vm._h('ul', [_vm._l((_vm.items), function(item) {
    return _vm._h('li', ["\n    " + _vm._s(item) + "\n  "])
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5405dc2c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/List.vue
// module id = 128
// module chunks = 2